import moment from "moment";
import { s3baseUrl } from "src/config/config";

export function download_csv_file(csv, csvFileData, fileName) {
  const headerRow = csv.map((column) => column.label);
  const csvRows = [headerRow];

  csvFileData.forEach((row) => {
    const dataRow = csv.map((column) => {
      let value = row[column.key] || column.defaultValue || "";
      if (value !== null && value !== undefined) {
        value = String(value);
      }
      if (value && value.includes(",")) {
        return `"${value}"`;
      }
      return value;
    });

    csvRows.push(dataRow);
  });

  const csvContent = csvRows.map((row) => row.join(",")).join("\n");
  const hiddenElement = document.createElement("a");
  hiddenElement.href =
    "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
  hiddenElement.target = "_blank";
  hiddenElement.download = fileName ? fileName : "file.csv";
  hiddenElement.click();
}

export const downloadFile = (fileURL) => {
  const url =
    fileURL instanceof File
      ? URL.createObjectURL(fileURL)
      : s3baseUrl + fileURL;

  const link = document.createElement("a");
  link.href = url;
  link.download =
    fileURL instanceof File ? fileURL.name : fileURL.split("/").pop() || "file";

  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const capitalizeFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function htmlReturnFromCKEditor(str) {
  return <div dangerouslySetInnerHTML={{ __html: str }} />;
}

export const getNumberformat = (value) => {
  if (value == null || value === "") return "";

  const num = Number(value);

  // if integer → no decimals
  if (Number.isInteger(num)) {
    return "integer";
  }
  // else keep up to 2 decimals (trim trailing zeros)
  return "float";
};

export const getFormattedNumber = (value, decimals = 2) => {
  // Convert to number
  const num = Number(value);

  // Return 0 for invalid values
  if (!Number.isFinite(num)) return 0;

  // Prevent negative zero (-0)
  const rounded =
    Math.round((num + Number.EPSILON) * Math.pow(10, decimals)) /
    Math.pow(10, decimals);

  return Object.is(rounded, -0) ? 0 : rounded;
};
const handleCalculateTax1 = () => {
  const annualIncome = monthlySalary * 12;
  const tax = calculateTax(annualIncome);

  const roundedAmount = Math.ceil(tax);
  // const roundedAmount = Math.floor(tax);
  setAnnualTax(roundedAmount);
};

export function calculateTax(annualIncome) {
  let tax = 0;

  if (annualIncome <= 600000) {
    tax = 0;
  } else if (annualIncome <= 1200000) {
    tax = 0.01 * (annualIncome - 600000);
  } else if (annualIncome <= 2200000) {
    tax = 6000 + 0.11 * (annualIncome - 1200000);
  } else if (annualIncome <= 3200000) {
    tax = 116000 + 0.2 * (annualIncome - 2200000);
  } else if (annualIncome <= 4100000) {
    tax = 316000 + 0.25 * (annualIncome - 3200000);
  } else if (annualIncome <= 5600000) {
    tax = 541000 + 0.29 * (annualIncome - 4100000);
  } else if (annualIncome <= 7000000) {
    tax = 976000 + 0.32 * (annualIncome - 5600000);
  } else {
    tax = 1424000 + 0.35 * (annualIncome - 7000000);
  }

  return tax;
}

export function handleCalculateTax(monthlySalary) {
  const annualIncome = monthlySalary * 12;
  const tax = calculateTax(annualIncome);

  const roundedAmount = Math.round(tax);
  let annualTax = roundedAmount;
  let MonthlyTax = (annualTax / 12).toFixed(2);
  return MonthlyTax;
}
export function handleCalculateTaxNew(allowances, gross_salary, type) {
  let percentageAllowance = 0;
  let allAmountAllowance = 0;
  let percentageCombineAmount = 1;
  let newCalculateGrossSalary = gross_salary;
  let amountBeforeTax = 0;
  let amountAfterTax = 0;
  let tax = 0;
  let totalExemptAllowance = 0;

  allowances
    .filter((allowance) => allowance.exempt_from_tax_calculation)
    .map((allowance, index) => {
      totalExemptAllowance = totalExemptAllowance + 1;
      if (allowance?.allowance_amount_type == "percentage") {
        percentageAllowance =
          percentageAllowance +
          parseFloat(allowance?.allowance_amount_or_percentage);
      } else {
        allAmountAllowance =
          allAmountAllowance +
          parseFloat(allowance?.allowance_amount_or_percentage);
      }
    });

  percentageCombineAmount = 1 + percentageAllowance / 100;
  newCalculateGrossSalary = gross_salary / percentageCombineAmount;
  amountBeforeTax = newCalculateGrossSalary - allAmountAllowance;
  tax = handleCalculateTax(amountBeforeTax);
  amountAfterTax = amountBeforeTax - tax;

  if (type == "basic_salary") {
    return Math.round(amountBeforeTax);
  }
  if (type == "exempt_amount") {
    let exempt_amount = gross_salary - amountBeforeTax;
    let totalDivisionAllowance = allowances?.length || totalExemptAllowance;
    return Math.round(exempt_amount / totalDivisionAllowance);
  }
  return Math.round(tax);
  // return parseInt(tax);
}

export function handleCalculateBasicSalaryFromGrossSalary(
  allowances,
  gross_salary,
) {
  let percentageAllowance = 0;
  let allAmountAllowance = 0;
  let percentageCombineAmount = 1;
  let newCalculateGrossSalary = gross_salary;

  allowances.map((allowance, index) => {
    if (allowance?.allowance_amount_type == "percentage") {
      percentageAllowance =
        percentageAllowance +
        parseFloat(allowance?.allowance_amount_or_percentage);
    } else {
      allAmountAllowance =
        allAmountAllowance +
        parseFloat(allowance?.allowance_amount_or_percentage);
    }
  });

  newCalculateGrossSalary = gross_salary - allAmountAllowance;
  percentageCombineAmount = 1 + percentageAllowance / 100;
  newCalculateGrossSalary = newCalculateGrossSalary / percentageCombineAmount;

  return Number(Math.round(newCalculateGrossSalary));
}

export const calculateGrossEarnings = (
  grossSalary,
  otherAllowances,
  type = "string",
) => {
  if (grossSalary === undefined) {
    if (type == "number") {
      return 0;
    } else {
      return "Rs. 0";
    }
  }

  const otherAllowancesSum = returnSumOfAllowances(
    otherAllowances,
    grossSalary,
  );

  const calculatedGrossEarnings =
    Math.round((grossSalary + otherAllowancesSum) * 10) / 10;

  if (type == "number") {
    return calculatedGrossEarnings;
  } else {
    return `Rs. ${calculatedGrossEarnings}`;
  }
};

const returnSumOfAllowances = (allowances, basicSalary) => {
  let totalAmount = 0;
  if (Array.isArray(allowances)) {
    totalAmount = allowances.reduce((sum, allowance) => {
      let allowanceAmount = allowance.allowance_amount
        ? allowance.allowance_amount
        : calculateAllowanceAmount(basicSalary, allowance, "number");
      return sum + allowanceAmount;
    }, 0);
  }

  return totalAmount;
};
export const returnSumOfAmount = (_array) => {
  let totalAmount = 0;
  if (Array.isArray(_array)) {
    totalAmount = _array.reduce((sum, obj) => {
      return sum + obj.amount;
    }, 0);
  }

  return totalAmount;
};

export const calculateMemberTax = (allowance, salary) => {
  let allNewAllowances =
    allowance &&
    allowance.length > 0 &&
    allowance
      .filter((allowance) => !allowance.exempt_from_tax_calculation) // Filter only exempt allowances
      .map((allowance) => {
        return {
          title: allowance?.title,
          allowance_amount_or_percentage: allowance.allowance_amount,
        };
      });

  let allowancesAmountSum = returnAllowanceAmountSum(allNewAllowances);
  let taxableSalary = salary + allowancesAmountSum;

  let _monthly_tax = handleCalculateTax(taxableSalary);
  let _monthly_tax_value = Math.round(_monthly_tax);
  return _monthly_tax_value;
};

export const returnAllowanceAmountSum = (amountArray) => {
  let totalAmount = 0;

  if (Array.isArray(amountArray)) {
    // Check if amountArray is indeed an array
    totalAmount = amountArray.reduce((sum, field) => {
      // Parse the allowance_amount_or_percentage as a number
      const amount = parseInt(field.allowance_amount_or_percentage) || 0;
      return sum + amount;
    }, 0);
  }

  return totalAmount;
};

export const calculateAllowanceAmount = (
  basic_salary,
  allowance,
  type = "string",
) => {
  let amount = 0;
  amount = allowance?.allowance_amount_or_percentage;
  if (allowance?.allowance_amount_type === "percentage") {
    amount = basic_salary * (allowance?.allowance_amount_or_percentage / 100);
  }

  if (type == "number") {
    return Number(Math.round(amount));
  } else {
    return `Rs. ${Math.round(amount)}`;
  }
};

export const calculateNetSalary = (obj) => {
  let salary =
    obj.gross_earnings -
    obj.monthly_tax -
    (obj.deductionsObjcet?.fine.deducted || 0) -
    (obj.deductionsObjcet?.lunch.deducted || 0) -
    (obj.deductionsObjcet?.leave.deducted || 0) -
    (obj.pending_dues || 0) -
    (obj.shop_items_deduction || 0) -
    (obj?.deduction?.loan || 0) -
    (obj?.deduction?.advance_salary || 0);

  return (salary = Math.round(salary * 100) / 100);
};

export const getPendingInstallmentForMonth = (
  loanObj,
  targetDate = moment(),
) => {
  if (
    !loanObj ||
    !Array.isArray(loanObj.installments) ||
    loanObj?.status == "pending"
  ) {
    return 0;
  }

  return loanObj.installments
    .filter((inst) => {
      if (!inst || inst.status !== "pending" || !inst.due_date) return false;

      return moment(inst.due_date).isSame(targetDate, "month");
    })
    .reduce((sum, inst) => sum + (Number(inst.amount) || 0), 0);
};

export const nonGroupLeavesCategories = ["casual", "trip", "non_paid", "other"];

export function getWeekRanges(weekCount = 1, skipWeeks = 2) {
  const ranges = [];

  const today = new Date();

  // Start after skipWeeks weeks
  const startDate = new Date();
  startDate.setDate(today.getDate() + skipWeeks * 7);

  // Move to next Monday
  while (startDate.getDay() !== 1) {
    startDate.setDate(startDate.getDate() + 1);
  }

  // End after 6 months
  const endLimit = new Date();
  endLimit.setMonth(endLimit.getMonth() + 6);

  let current = new Date(startDate);

  while (current <= endLimit) {
    const start = new Date(current);

    // Friday of next week (Mon + 11 days)
    const end = new Date(current);
    end.setDate(end.getDate() + (weekCount == 1 ? 4 : 11));

    ranges.push({
      label: `${formatDate(start)} to ${formatDate(end)}`,
      value: {
        from: formatISO(start),
        to: formatISO(end),
      },
    });

    // Move 1 week forward (overlap)
    current.setDate(current.getDate() + 7);
  }

  return ranges;
}

function formatDate(date) {
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
}

function formatISO(date) {
  return date.toISOString().split("T")[0];
}

export const formatToDateTimeLocal = (isoString) => {
  if (!isoString) return "";

  return moment.utc(isoString).format("YYYY-MM-DDTHH:mm");
};
export const expense_payment_methods_array = [
  {
    value: "Cash",
    label: "Cash",
  },
  {
    value: "Petty Cash",
    label: "Petty Cash",
  },
  {
    value: "Bank Transfer",
    label: "Bank Transfer",
  },
  {
    value: "Online Payment",
    label: "Online Payment",
  },
  {
    value: "Cheque Payment",
    label: "Cheque Payment",
  },
  {
    value: "through_salary",
    label: "Through Salary",
  },
];

export const payment_methods_array = [
  {
    value: "Cash",
    label: "Cash",
  },
  {
    value: "Petty Cash",
    label: "Petty Cash",
  },
  {
    value: "Bank Transfer",
    label: "Bank Transfer",
  },
  {
    value: "Online Payment",
    label: "Online Payment",
  },
  {
    value: "Cheque",
    label: "Cheque",
  },
  {
    value: "Card Payment",
    label: "Card Payment",
  },
  {
    value: "Mobile Wallet",
    label: "Mobile Wallet",
  },
];

export const sponsorship_types = [
  {
    value: "paid",
    label: "Paid",
  },
  {
    value: "full",
    label: "Full Sponsored",
  },
  {
    value: "partial",
    label: "Partial Sponsored",
  },
];

export const isAllStatusDone = (statusObj = {}) => {
  return Object.entries(statusObj)
    .filter(([key]) => !key.endsWith("_date"))
    .every(([, val]) => val === true);
};

export const makeAPiQueryParams = (obj = {}) => {
  const params = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    params.append(key, value ?? "");
  });

  return params.toString();
};

export const formatLabel = (text = "") => {
  return text
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const htmlToText = (html) => {
  if (!html) return "";
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};
